import { useEffect } from 'react';

import { Platform } from 'react-native';

import { useSelector } from 'react-redux';

import { selectEpgPlayerFullscreen } from 'store/epg/selectors.ts';
import {
    selectPlayerConfig,
    selectSpotlightVideoVisible,
} from 'store/player/selectors.ts';

import { isWeb } from 'utils/responsiveness.ts';

const ACESSIBILITY_MODAL_UNDERLAYING_ELEMENT_CLASSNAME =
    'accessibility-modal-underlaying-element';
export const underlayingPlayerModalElementsDataSet = Platform.select({
    web: {
        class: ACESSIBILITY_MODAL_UNDERLAYING_ELEMENT_CLASSNAME,
    },
    default: undefined,
});

function useModalAccessibility() {
    const { visible: playerVisible } = useSelector(selectPlayerConfig);
    const epgPlayerFullscreen = useSelector(selectEpgPlayerFullscreen);
    const spotlightPlayerVisible = useSelector(selectSpotlightVideoVisible);

    useEffect(() => {
        if (isWeb) {
            if (
                playerVisible ||
                spotlightPlayerVisible ||
                epgPlayerFullscreen
            ) {
                const elements = document.querySelectorAll(
                    `div[data-class="${ACESSIBILITY_MODAL_UNDERLAYING_ELEMENT_CLASSNAME}"]`,
                );

                elements.forEach((element) => {
                    element.setAttribute('inert', 'true');
                    element.setAttribute('aria-hidden', 'true');
                });
            } else {
                const elements = document.querySelectorAll(
                    `div[data-class="${ACESSIBILITY_MODAL_UNDERLAYING_ELEMENT_CLASSNAME}"]`,
                );

                elements.forEach((element) => {
                    element.removeAttribute('inert');
                    element.removeAttribute('aria-hidden');
                });
            }
        }
    }, [playerVisible, epgPlayerFullscreen, spotlightPlayerVisible]);
}

export default useModalAccessibility;
